import contractInfos from "./contractInfos"
import workDays from "./workDays"
import roles from "./roles"
import institutes from "./institutes"

export const users = [
    {
        "id": "465d2582-ec40-4aee-8a78-902252d44997",
        "name": "Matt Tzuker",
        "isAllowedFlexTimeAccount" : true,
        "hasFlexTimeAccount": null,
        "startOfFlexTimeAccount": "2024-01-01",
        "initialFlexTimeAccountBalance": "00:00:00",
        "contractInfo": "20c94fc2-0414-48bc-b006-d289e93e8fe4",
        "roles": roles.slice(0, 2),
    },
    {
        "id": "94608706-2beb-4551-b131-df9a2d7da88c",
        "name": "Isabella Enser",
        "isAllowedFlexTimeAccount" : true,
        "hasFlexTimeAccount": true,
        "startOfFlexTimeAccount": "2024-01-01",
        "initialFlexTimeAccountBalance": "00:00:00",
        "contractInfo": "e42ecbdc-1e4e-40b3-946b-d35f7339e2d1",
        "initialWorkingTimeBalance": 141,
        "roles": roles.slice(0, 3),
    },
    {
        "id": "64b6f377-fb62-48cf-a171-9d9e746f109f",
        "name": "Rodi Eborn",
        "isAllowedFlexTimeAccount" : false,
        "hasFlexTimeAccount": false,
        "startOfFlexTimeAccount": null,
        "contractInfo": "",
        "initialWorkingTimeBalance": 0,
        "roles": roles.slice(0, 1),
    }
]

export default users.map((user, index) => {
    return {
        id: user.id,
        name: user.name,
        institute: institutes[index % institutes.length].name,
        location: institutes[index % institutes.length].locations[index % institutes[index % institutes.length].locations.length],
        isAllowedFlexTimeAccount: user.isAllowedFlexTimeAccount,
        hasFlexTimeAccount: user.isAllowedFlexTimeAccount ? user.hasFlexTimeAccount : null,
        startOfFlexTimeAccount : user.isAllowedFlexTimeAccount ? user.startOfFlexTimeAccount : null,
        initialFlexTimeAccountBalance: user.isAllowedFlexTimeAccount ? user.initialFlexTimeAccountBalance : null,
        contractInfo: user.hasFlexTimeAccount ? contractInfos[index] : null,
        roles: user.roles,
        workDays: workDays,
    }
})
